import { useInfiniteQuery } from '@tanstack/react-query';

import { SearchCategory } from '../model/types';
import { PageResponseSearchHitResponse } from './Search';
import useSearchService from './search.service';
import { searchKeys } from './searchApi';

export function useSearchByCategoryQuery(query: string, category: SearchCategory | null) {
  const { searchByCategory } = useSearchService();

  return useInfiniteQuery<PageResponseSearchHitResponse>({
    queryKey: searchKeys.sub('byCategory', category, query),
    queryFn: ({ pageParam = 0, signal }) =>
      searchByCategory(query, category!, pageParam as number, signal),
    getNextPageParam: (lastPage, pages) => {
      const loaded = pages.reduce((count, page) => count + page.content.length, 0);
      return loaded < lastPage.totalElements ? pages.length : undefined;
    },
    enabled: Boolean(category) && query.trim().length > 0,
  });
}
